'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 框架状态
 * 
 * @export
 * @class FrameworkState
 */
var FrameworkState =

/**
 * 新建一个状态
 * 
 * @ignore
 * @param {string} state 
 * @memberof FrameworkState
 */

/**
 * 正在停止状态
 * 
 * @static
 * @memberof FrameworkState
 */

/**
 * 创建状态
 * 
 * @static
 * @memberof FrameworkState
 */
function FrameworkState(state) {
  (0, _classCallCheck3.default)(this, FrameworkState);

  this.state = state;
  (0, _freeze2.default)(this);
}

/**
 * 枚举的所有成员
 * 
 * @static
 * @memberof FrameworkState
 */

/**
 * 停止状态
 * 
 * @static
 * @memberof FrameworkState
 */

/**
 * 启动状态
 * 
 * @static
 * @memberof FrameworkState
 */
;

FrameworkState.CREATED = new FrameworkState('created');
FrameworkState.STARTED = new FrameworkState('started');
FrameworkState.STOPPING = new FrameworkState('stopping');
FrameworkState.STOPPED = new FrameworkState('stopped');

FrameworkState.values = function () {
  var enumValues = [];
  enumValues.push(FrameworkState.CREATED);
  enumValues.push(FrameworkState.STARTED);
  enumValues.push(FrameworkState.STOPPING);
  enumValues.push(FrameworkState.STOPPED);
  return enumValues;
};

exports.default = FrameworkState;


(0, _freeze2.default)(FrameworkState);
//# sourceMappingURL=FrameworkState.js.map